import {TypeMap, TypeSat} from 'topmeteo/general/constants';

import Wrapper from './Wrapper';

export {TypeMap, TypeSat};

export default Wrapper;
